module.exports = __webpack_public_path__ + "static/img/select.be2885c0.svg";